<template>
    <v-container class="text-xs-center">
        <v-icon
            color="primary"
            size="72"
            class="mb-3"
        >
            fas fa-exclamation-triangle
        </v-icon>
        <h1 class="display-1">
            Page Not Found
        </h1>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>
